import type React from "react";

import {
  type Breadcrumb as DesignSystemBreadcrumb,
  Breadcrumbs as DesignSystemBreadcrumbs,
} from "@/design-system/Breadcrumbs";
import { useTranslation } from "@/translations";

export interface BreadcrumbsProps {
  pages: Breadcrumb[];
}
export function Breadcrumbs({ pages }: BreadcrumbsProps): React.ReactNode {
  const { t } = useTranslation();

  return <DesignSystemBreadcrumbs pages={pages} overflowLabel={t("component.context-menu.action.open")} />;
}

export type Breadcrumb = DesignSystemBreadcrumb;
